import { emailRegExp } from './regExps.js'


export const validateEmail = (value) => (emailRegExp.test(value))
export const validatePhone = (value) => (value.length >= 11 ? true : false)

